import { render, staticRenderFns } from "./CarouselForm.vue?vue&type=template&id=19516881&"
import script from "./CarouselForm.vue?vue&type=script&lang=js&"
export * from "./CarouselForm.vue?vue&type=script&lang=js&"
import style0 from "./CarouselForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports